<template>
	<div>
		<notifications group="global" />
		<TopNav @toggle-menu="toggleMenu()" :menuOpen="menuOpen" home="psychic" />
		<div class="container">
			<div class="columns">
				<SideNav @toggle-menu="toggleMenu()" :menuOpen="menuOpen" />
				<slot />
			</div>
			<Footer/>
		</div>
	</div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import Footer from '../components/Footer.vue'
import SideNav from '../components/psychic/SideNav.vue'

export default {
	components: {
		TopNav,
		Footer,
		SideNav
	},
	data() {
		return {
			menuOpen: false,
			user_id: null,
			chatWindow: null,
			interval: null
		}
	},
	methods: {
		toggleMenu() {
			this.menuOpen = !this.menuOpen
		},
		openChat() {
			if (this.chatWindow === null || this.chatWindow.closed) {
				this.chatWindow = window.open(`${this.$root.$data.state.baseApiUri.replace("https", "http")}/chat`, 
				"chatWindow",`status=no,resizable=yes,menubar=no,scrollbars=yes,width=600,height=600,left=${((screen.width - 600) / 2)},top=${((screen.height - 600) / 2)}`)	
			}
		},
		closeChat() {
			if (this.chatWindow !== null && !this.chatWindow.closed) {
				this.chatWindow.close()
				this.chatWindow = null
			}
		},
		async updateStatus() {
			const status = await this.$root.$data.getters.getStatus(this.$root.$data.state, this.user_id)
			if (["A", "C", "B", "R"].includes(status)) {
				if(!["B","R"].includes(status)) {
					this.openChat()
				}
			} else {
				this.closeChat()
			}

			console.log(this.chatWindow)
		}
	},
	created() {
			document.title = "Psychic Portal"
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			this.interval = setInterval(this.updateStatus, 3000)
	},
	beforeDestroy() {
		clearInterval(this.interval)
	}

}
</script>